import type { StepContentConfig } from '../../utils';

export const validationStepContent: StepContentConfig = {
    loadingText: {
        site: 'Votre souscription est en cours de validation...',
        conseiller: 'La souscription de votre client est en cours de validation...',
        conseillermae: 'La souscription de votre adhérent est en cours de validation...',
    },
};
